import { useState } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import { PER_PAGE_SIZE } from "../utils/constants";
import { exportPatient, getPatientAll } from "../services/PatientService";
import { downloadBlob } from "../utils/utils";
import { useNotification } from "../context/NotificationProvider";
import { useLocalization } from "../context/LocalizeContextProvider";

export default function usePatient() {
  const notification = useNotification();
  const localize = useLocalization();

  const [page, setPage] = useState(0);
  const [searchName, setSearchName] = useState("");
  const [searchNoTelp, setSearchNoTelp] = useState("");
  const [searchDate, setSearchDate] = useState("");
  const [searchAddress, setSearchAddress] = useState("");
  const [searchNoRm, setSearchNoRm] = useState("");

  const [totalPage, setTotalPage] = useState(0);
  const [totalEntries, setTotalEntries] = useState(0);
  const [dataPatient, setDataPatient] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(PER_PAGE_SIZE);

  const { isLoading, isRefetching, refetch } = useQuery(
    [
      "PatientList",
      page,
      searchName,
      searchNoTelp,
      searchDate,
      searchAddress,
      sizePerPage,
      searchNoRm,
    ],
    () =>
      getPatientAll({
        page,
        searchName,
        searchNoTelp,
        searchDate,
        searchAddress,
        size: sizePerPage,
        searchNoRm,
      }),
    {
      onSuccess: (data) => {
        if (data.status === 200) {
          setDataPatient(data?.data);
          setTotalEntries(Number(data.headers["x-total-count"]));
          setTotalPage(
            Math.ceil(Number(data.headers["x-total-count"]) / sizePerPage)
          );
        }
      },
    }
  );

  const { isLoading: isLoadingExport, mutate: mutateExport } = useMutation(
    ["ExportPatient"],
    () => exportPatient(),
    {
      onSuccess: (res) => {
        if (res.status === 200 || res.status === 201) {
          downloadBlob(res.data, "patient-data");
        } else {
          notification.error(
            res?.data?.detail || localize.getText("unknownMessageError")
          );
        }
      },
    }
  );

  const handlePagination = (value) => {
    setPage(value);
  };

  const handleSetFilter = (
    searchName,
    searchNoTelp,
    searchDate,
    searchAddress,
    searchNoRm
  ) => {
    setSearchName(searchName);
    setSearchNoTelp(searchNoTelp);
    setSearchDate(searchDate);
    setSearchAddress(searchAddress);
    setSearchNoRm(searchNoRm);
    setPage(0);
  };

  const handleSetSizePerPage = (size) => {
    setPage(0);
    setSizePerPage(size);
  };

  return {
    page,
    totalPage,
    totalEntries,
    dataPatient,
    isLoading,
    isRefetching,
    isLoadingExport,
    sizePerPage,
    setSizePerPage: handleSetSizePerPage,
    refetch,
    handlePagination,
    handleSetFilter,
    handleExport: mutateExport,
    filterSearch: {
      searchName,
      searchNoTelp,
      searchDate,
      searchAddress,
    },
  };
}
